import React, { useRef } from "react";
import Modal from 'react-modal';
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";
import { useWindowWidth } from "@react-hook/window-size";

Modal.setAppElement('#__next');

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        border                : 'none',
        backgroundColor       : '#fffdf8',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)',
        padding               : '0',
        overflow              : 'visible',
        borderRadius          : '8px',
        boxShadow: "0 8px 16px -2px rgba(28, 17, 13, 0.2), 0 -2px 8px -4px rgba(0, 0, 0, 0.1)"
    },

    overlay : {
        zIndex: 19000
    }
};

const mobileCustomStyles = {
    content: {
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        overflowY: 'auto',
        padding: '0',
        backgroundColor: '#fffdf8',
    },

    overlay: {
        zIndex: 19000
    }
};


const ShFullscreenModal = ({children, isOpen, contentLabel, onRequestClose}: any) => {

    const width = useWindowWidth();
    const targetRef = useRef<any>();

    return <>
        <Modal ref={targetRef} onRequestClose={onRequestClose}
               isOpen={isOpen} contentLabel={contentLabel}

               onAfterOpen={
                   () => {
                     // const modalHTML = window.document.querySelector(".ReactModal__Content");
                     disableBodyScroll(targetRef.current.node);
                   }
               }

               onAfterClose={
                   () => {
                        clearAllBodyScrollLocks();
                   }
               }

               style={ width <= 576 ? mobileCustomStyles : customStyles }>
            {children}
        </Modal>
    </>;
};

export default ShFullscreenModal;
